import openCompanyTab from './tab';
import Inspector from './inspector';

const { RichText, InnerBlocks } = wp.blockEditor;
const { useRef, useEffect } = wp.element;

export default ({ attributes, setAttributes }) => {
  const { title, margin } = attributes;

  const tabDefault = useRef(null);
  const allowedBlocksPlans = ['block/tabs-company-item'];

  useEffect(() => {
    tabDefault.current.click();
  }, [tabDefault]);

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <section className={`TabsCompany ${margin}`}>
        <RichText
          tagName="h2"
          className="Typography title-4 center color-blue-dark margin-base"
          placeholder={'Título (tag h2)'}
          value={title}
          keepPlaceholderOnFocus
          onChange={(title) => setAttributes({ title })}
        />

        <div className="Container">
          <div className="TabsCompany__tabs">
            <button
              className="TabsCompany__link"
              onClick={(event) => openCompanyTab(event, 'pme')}
              ref={tabDefault}
            >
              PME
            </button>
            <button
              className="TabsCompany__link"
              onClick={(event) => openCompanyTab(event, 'corporativo')}
            >
              Corporativo
            </button>
          </div>
        </div>

        <InnerBlocks allowedBlocks={allowedBlocksPlans} />
      </section>
    </>
  );
};
